import { Row, Col, Form } from "react-bootstrap";
import { useImperativeHandle, forwardRef, useState } from "react";
import { Action, Status } from "../utility/common/constants/CommonConstants";
import { isAllowCustomSpecialCharacters, isAlphanumericWithPlusAmpersandEqualsPercentMinus } from "../../functions/validations";
import { WPQHeader } from "./WPQObjects/WPQHeader";
import { WPQPage3Table3observation, PQRPage3TableColumnN, PQRPage3TableColumnNindex } from "../utility/common/TransactionComponents/WPQ_PQR_Test_Table_Components";
import { UpdateWPQDetailComplete, check_TestArray, check_MacroMicroTest, check_MinimumLeakPath } from "./WPQObjects/WPQ_Validations";
import { WPQ_tubePage3 } from "./WPQObjects/WPQ_entity";
import { AddNewGrooveWPQ } from "../../Services/wpq_groove-services";
import { emptyError, handleCount } from "./WPQObjects/WPQCommonUtils";
import { validateForm, handleChangeNotesFlexible } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import { handleWPQGeneralSubmit, handleWPQGeneralSubmitTemp } from "../utility/common/TransactionComponents/TransactionSubmitUtils";
import { SingleInput } from "../utility/forms/inputs/InputsTransaction";
import PropTypes from "prop-types";
import { showWarning } from "../utility/ui/notifications/Toaster";
import { DotLoader } from "react-spinners";

const WPQ_Tubesheet_Page3 = forwardRef(
  (
    { headerObj, setheaderObj, detailObj, setdetailObj, isDisabled, setAction },
    ref
  ) => {
    WPQ_Tubesheet_Page3.propTypes = {
      headerObj: PropTypes.array,
      setheaderObj: PropTypes.func,
      setdetailObj: PropTypes.func,
      isDisabled: PropTypes.bool,
      detailObj: PropTypes.array,
      setAction: PropTypes.func,
    };

    const [IsEdited, setIsEdited] = useState(false);
    const [loading, setLoading] = useState(false);
    let Visual_Examination = detailObj?.Visual_Examination;
    let Macro_Examination5 = detailObj?.Macro_Examination5;
    let Liquid_Penetrant_Examination = detailObj?.Liquid_Penetrant_Examination;
    let object = detailObj?.Macro_Examination;
    let array = { ...object };
    let element = array[0];
    let data = { ...element };
    let Table1 = data.Table1;
    let Table2 = data.Table2;
    let Macro_Examination1 = Table1;
    let Macro_Examination2 = Table2;

    const [error, setError] = useState({
      WPQ_VEX_WeldPass: {},
      WPQ_VEX_Acceptance_Criteria: {},
      WPQ_VEX_Observation: {},
      WPQ_VEX_Results: {},

      WPQ_LPEX_WeldPass: {},
      WPQ_LPEX_Acceptance_Criteria: {},
      WPQ_LPEX_Observation: {},
      WPQ_LPEX_Results: {},

      WPQ_MEX_Tube_No: {},
      WPQ_MEX_LocA: {},
      WPQ_MEX_LocB: {},
      WPQ_MEX_LocC: {},
      WPQ_MEX_LocD: {},

      WPQ_MEX_Tube_No1: {},
      WPQ_MEX_LocA1: {},
      WPQ_MEX_LocB1: {},
      WPQ_MEX_LocC1: {},
      WPQ_MEX_LocD1: {},

      WPQ_MEX_Tube_No2: {},
      WPQ_MEX_LocA2: {},
      WPQ_MEX_LocB2: {},
      WPQ_MEX_LocC2: {},
      WPQ_MEX_LocD2: {},

      WPQ_MEX_Tube_No3: {},
      WPQ_MEX_LocA3: {},
      WPQ_MEX_LocB3: {},
      WPQ_MEX_LocC3: {},
      WPQ_MEX_LocD3: {},

      WPQ_VEX_Report: {},
      WPQ_LPEX_Report: {},
      WPQ_LPEX_Notes: {},
      WPQ_VEX_Notes: {},
      WPQ_MEX_Result: {},

      WPQ_MEX_Magnification: {},
      WPQ_MEX_Acceptance_Criteria: {},
      WPQ_MEX_Observation: {},
    });

    const validate = async () => {
      let temperror = emptyError(error, setError, false);

      // 1. Use common validation for simple fields
      const validationResult = validateForm({
        headerObj: detailObj,
        detailObj,
        requiredFields: WPQ_tubePage3,
        detailConfig: [], // Empty - no array validation here
        currentErrors: error,
      });

      let isError = validationResult.isError;
      let finalErrors = validationResult.errors;
      // 2. Custom validation for test arrays using new function signature
      if (check_TestArray(Visual_Examination, ["WPQ_VEX_WeldPass", "WPQ_VEX_Acceptance_Criteria", "WPQ_VEX_Observation", "WPQ_VEX_Results"], 2)) {
        isError = true;
      }

      if (check_TestArray(Liquid_Penetrant_Examination, ["WPQ_LPEX_WeldPass", "WPQ_LPEX_Acceptance_Criteria", "WPQ_LPEX_Observation", "WPQ_LPEX_Results"], 2)) {
        isError = true;
      }

      if (check_MinimumLeakPath(Macro_Examination5, ["WPQ_MEX_Magnification", "WPQ_MEX_Acceptance_Criteria"], 2)) {
        isError = true;
      }

      if (check_MacroMicroTest(Macro_Examination1, ["WPQ_MEX_Tube_No", "WPQ_MEX_LocA", "WPQ_MEX_LocB", "WPQ_MEX_LocC", "WPQ_MEX_LocD"], 4)) {
        isError = true;
      }

      // 3. Apply all errors at once
      setError(finalErrors);

      return { isError, temperror };
    };

    const handleAdd = async () => {
      let result = false;
      if (
        headerObj?.WPSH_Status === Status.StatusApproved ||
        headerObj?.WPSH_Status === Status.StatusRejected
      ) {
        headerObj.WPSH_Status = Status.StatusPending;
        if (headerObj?.WPSH_Status === Status.StatusApproved) handleCount();
      }

      let VEX = {
        wld_createdon: detailObj.wld_createdon || "",
        WPQ_WelderId: detailObj.WPQ_WelderId,
        WPQ_RecordNo: detailObj.WPQ_RecordNo,
        WPQ_Process: detailObj.WPQ_Process,
        WPSD_FM_SFA: detailObj.WPSD_FM_SFA,
        WPQ_VEX_Report: detailObj.WPQ_VEX_Report,
        WPQ_VEX_Notes: detailObj.WPQ_VEX_Notes,
        Visual_Examination: detailObj.Visual_Examination,
      };

      let LiqEx = {
        wld_createdon: detailObj.wld_createdon || "",
        WPQ_WelderId: detailObj.WPQ_WelderId,
        WPQ_RecordNo: detailObj.WPQ_RecordNo,
        WPQ_Process: detailObj.WPQ_Process,
        WPSD_FM_SFA: detailObj.WPSD_FM_SFA,
        WPQ_LPEX_Report: detailObj.WPQ_LPEX_Report,
        WPQ_LPEX_Notes: detailObj.WPQ_LPEX_Notes,
        Liquid_Penetrant_Examination: detailObj.Liquid_Penetrant_Examination,
      };

      let Macro_ExaminationArray = [
        {
          Table1: Macro_Examination1,
          Table2: Macro_Examination2,
        },
      ];

      let MacroEx = {
        wld_createdon: detailObj.wld_createdon || "",
        WPQ_WelderId: detailObj.WPQ_WelderId,
        WPQ_RecordNo: detailObj.WPQ_RecordNo,
        WPQ_Process: detailObj.WPQ_Process,
        WPSD_FM_SFA: detailObj.WPSD_FM_SFA,
        WPQ_MEX_Result: detailObj.WPQ_MEX_Result,
        Macro_Examination: Macro_ExaminationArray,
      };

      let MacroEx5 = {
        wld_createdon: detailObj.wld_createdon || "",
        WPQ_WelderId: detailObj.WPQ_WelderId,
        WPQ_RecordNo: detailObj.WPQ_RecordNo,
        WPQ_Process: detailObj.WPQ_Process,
        WPSD_FM_SFA: detailObj.WPSD_FM_SFA,
        Macro_Examination5: detailObj.Macro_Examination5,
        WPQ_MEX_Observation: detailObj.WPQ_MEX_Observation,
      };

      const postList = [VEX, LiqEx, MacroEx, MacroEx5];

      let res = await AddNewGrooveWPQ(headerObj);
      console.log("headerObj1", headerObj);
      let resdet = await UpdateWPQDetailComplete(postList);
      console.log("ressssa", res, resdet);

      if (res !== undefined && resdet !== "SpecialCharacters") {
        result = true;

        setAction(Action.ActionEdit);
      } else {
        showWarning(process.env.REACT_APP_SPECIAL_CHARACTER_MSG);
      }
      return result;
    };

    const validateTemp = async () => {
      let isError = false;

      let temperror = emptyError(error, setError, isError);

      return { isError, temperror };
    };

    const handleSubmit = () => handleWPQGeneralSubmit(validate, handleAdd, setLoading, setIsEdited, Status.StatusPending);
    const handleSubmitTemp = () => handleWPQGeneralSubmitTemp(IsEdited, validateTemp, handleAdd, setLoading, setIsEdited, headerObj?.WPQH_Status || Status.StatusTempSaved);

    useImperativeHandle(ref, () => ({
      funcOnNext3: async () => {
        return await handleSubmit();
      },

      funcOnNextTemp3: async () => {
        return await handleSubmitTemp();
      },
    }));

    const handleChangetestarray = (Index, key, newValue) => {
      setIsEdited(true);
      const updatedheadertestObj = { ...detailObj };

      updatedheadertestObj.Visual_Examination[Index][key] = newValue;
      setdetailObj(updatedheadertestObj);
    };

    const handleChangeLiquid_Penetrant_Examinationarray = (
      Index,
      key,
      newValue
    ) => {
      setIsEdited(true);
      const updatedheadertestObj = { ...detailObj };

      updatedheadertestObj.Liquid_Penetrant_Examination[Index][key] = newValue;
      setdetailObj(updatedheadertestObj);
    };

    const handleChangeMacro_Examinationarray = (
      Index,
      key,
      table,
      newValue
    ) => {
      setIsEdited(true);
      const updatedheadertestObj = { ...detailObj };

      updatedheadertestObj.Macro_Examination[0][table][Index][key] = newValue;
      setdetailObj(updatedheadertestObj);
    };

    const handleChangeMacro_Examinationarray5 = (
      Index,
      key,
      table,
      newValue
    ) => {
      setIsEdited(true);
      const updatedheadertestObj = { ...detailObj };

      updatedheadertestObj.Macro_Examination5[Index][key] = newValue;
      setdetailObj(updatedheadertestObj);
    };

    const handleChangedetail = (e, i) => {
      setIsEdited(true);
      const { name, value } = e.target;
      setdetailObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const [valueNotes, setValueNotes] = useState("");

    const handleChangeNotes = (e) => {
      handleChangeNotesFlexible(e, {
        setIsEdited,
        setStateObj: setdetailObj,
        setValueNotes,
        maxNewLines: 2,
        maxLineLength: 45
      });
    };

    return (
      <fieldset disabled={isDisabled}>
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <Row className="font">
          <WPQHeader headerObj={headerObj}></WPQHeader>
          <Row style={{ padding: "20px 60px" }}>
            <Row className="mb-1">
              <Col md={12}>
                <p className="WPS-blue-text " style={{ position: "relative", top: "10px" }}>
                  Visual Examination{" "}
                </p>
                <PQRPage3TableColumnN
                  columns={4}
                  maxLength={[24, 16, 16, 23]}
                  width={[200, 120, 120, 180]}
                  session="WPQ"
                  array={Visual_Examination}
                  setheaderObj={setheaderObj}
                  numberofrowsdisabled={0}
                  setError={setError}
                  title={[
                    "Weld Pass",
                    "Acceptance Criteria",
                    "Observation",
                    "Results",
                  ]}
                  name={[
                    "WPQ_VEX_WeldPass",
                    "WPQ_VEX_Acceptance_Criteria",
                    "WPQ_VEX_Observation",
                    "WPQ_VEX_Results",
                  ]}
                  status={[
                    error.WPQ_VEX_WeldPass.status,
                    error.WPQ_VEX_Acceptance_Criteria.status,
                    error.WPQ_VEX_Observation.status,
                    error.WPQ_VEX_Results.status,
                  ]}
                  message={[
                    error.WPQ_VEX_WeldPass.message,
                    error.WPQ_VEX_Acceptance_Criteria.message,
                    error.WPQ_VEX_Observation.message,
                    error.WPQ_VEX_Results.message,
                  ]}
                  handleChangetestarray={handleChangetestarray}
                />
              </Col>
              <Col className="mt-3" md={6}>
                <SingleInput
                  disabled={isDisabled}
                  name="WPQ_VEX_Report"
                  type="text"
                  maxLength={95}
                  status={error.WPQ_VEX_Report.status}
                  value={detailObj?.WPQ_VEX_Report}
                  onChange={handleChangedetail}
                  label="Report No."
                  message={error.WPQ_VEX_Report.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="&±+-=%"
                  customMessage="Special Characters # + $ ' < >  ; not allowed"
                ></SingleInput>
              </Col>
              <span className="WPS-blue-text" style={{ position: "relative", top: "10px" }}>
                Notes
              </span>
              <Col md={12}>
                <SingleInput
                  disabled={isDisabled}
                  name="WPQ_VEX_Notes"
                  type="text"
                  maxLength={95}
                  status={error.WPQ_VEX_Notes.status}
                  value={detailObj?.WPQ_VEX_Notes}
                  onChange={handleChangedetail}
                  label="Notes"
                  message={error.WPQ_VEX_Notes.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="&±+-=%"
                  customMessage="Special Characters # + $ ' < >  ; not allowed"
                ></SingleInput>
              </Col>
            </Row>
          </Row>
          <Row style={{ padding: "20px 60px" }} className="WPQ-Page-row-padding">
            <Row className="mb-1">
              <Col md={12}>
                <p className="WPS-blue-text " style={{ position: "relative", top: "10px" }}>
                  Liquid Penetrant Examination{" "}
                </p>
                <PQRPage3TableColumnN
                  columns={4}
                  maxLength={[24, 16, 16, 23]}
                  width={[200, 120, 120, 180]}
                  session="WPQ"
                  array={Liquid_Penetrant_Examination}
                  setheaderObj={setheaderObj}
                  numberofrowsdisabled={0}
                  setError={setError}
                  title={[
                    "Weld Pass",
                    "Acceptance Criteria",
                    "Observation",
                    "Results",
                  ]}
                  name={[
                    "WPQ_LPEX_WeldPass",
                    "WPQ_LPEX_Acceptance_Criteria",
                    "WPQ_LPEX_Observation",
                    "WPQ_LPEX_Results",
                  ]}
                  status={[
                    error.WPQ_LPEX_WeldPass.status,
                    error.WPQ_LPEX_Acceptance_Criteria.status,
                    error.WPQ_LPEX_Observation.status,
                    error.WPQ_LPEX_Results.status,
                  ]}
                  message={[
                    error.WPQ_LPEX_WeldPass.message,
                    error.WPQ_LPEX_Acceptance_Criteria.message,
                    error.WPQ_LPEX_Observation.message,
                    error.WPQ_LPEX_Results.message,
                  ]}
                  handleChangetestarray={
                    handleChangeLiquid_Penetrant_Examinationarray
                  }
                />
              </Col>
              <Col className="mt-3" md={6}>
                <SingleInput
                  disabled={isDisabled}
                  name="WPQ_LPEX_Report"
                  type="text"
                  maxLength={95}
                  status={error.WPQ_LPEX_Report.status}
                  value={detailObj?.WPQ_LPEX_Report}
                  onChange={handleChangedetail}
                  label="Report No."
                  message={error.WPQ_LPEX_Report.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="&±+-=%"
                  customMessage="Special Characters # + $ ' < >  ; not allowed"
                ></SingleInput>
              </Col>
              <span className="WPS-blue-text" style={{ position: "relative", top: "10px" }}>
                Notes
              </span>
              <Col md={12}>
                <SingleInput
                  disabled={isDisabled}
                  name="WPQ_LPEX_Notes"
                  type="text"
                  maxLength={95}
                  status={error.WPQ_LPEX_Notes.status}
                  value={detailObj?.WPQ_LPEX_Notes}
                  onChange={handleChangedetail}
                  label="Notes"
                  message={error.WPQ_LPEX_Notes.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="&±+-=%"
                  customMessage="Special Characters # + $ ' < >  ; not allowed"
                ></SingleInput>
              </Col>
            </Row>
          </Row>
          <Row style={{ padding: "20px 60px" }}>
            <Row className="mb-1">
              <p className="WPS-blue-text " style={{ position: "relative", top: "10px" }}>Macro Examination{" "}</p>
              {/* ////////////////////////2nd table ////////////////////////////////////////////*/}
              <Col md={6}>
                <PQRPage3TableColumnNindex
                  columns={5}
                  maxLength={[3, 4, 4, 4, 4]}
                  width={245}
                  width1={245}
                  width2={245}
                  width3={245}
                  array={Macro_Examination1}
                  setheaderObj={setheaderObj}
                  setError={setError}
                  name={[
                    "WPQ_MEX_Tube_No",
                    "WPQ_MEX_LocA",
                    "WPQ_MEX_LocB",
                    "WPQ_MEX_LocC",
                    "WPQ_MEX_LocD",
                  ]}
                  table="Table1"
                  index={0}
                  title={["Tube No.", "Loc A", "Loc B", "Loc C", "Loc D"]}
                  numberofrowsdisabled={0}
                  status={[
                    error.WPQ_MEX_Tube_No.status,
                    error.WPQ_MEX_LocA.status,
                    error.WPQ_MEX_LocB.status,
                    error.WPQ_MEX_LocC.status,
                    error.WPQ_MEX_LocD.status,
                  ]}
                  message={[
                    error.WPQ_MEX_Tube_No.message,
                    error.WPQ_MEX_LocA.message,
                    error.WPQ_MEX_LocB.message,
                    error.WPQ_MEX_LocC.message,
                    error.WPQ_MEX_LocD.message,
                  ]}
                  handleChangetestarray={handleChangeMacro_Examinationarray}
                />
              </Col>
              <Col md={6}>
                <PQRPage3TableColumnNindex
                  columns={5}
                  maxLength={[3, 4, 4, 4, 4]}
                  width={245}
                  width1={245}
                  width2={245}
                  width3={245}
                  array={Macro_Examination2}
                  setheaderObj={setheaderObj}
                  setError={setError}
                  name={[
                    "WPQ_MEX_Tube_No",
                    "WPQ_MEX_LocA",
                    "WPQ_MEX_LocB",
                    "WPQ_MEX_LocC",
                    "WPQ_MEX_LocD",
                  ]}
                  table="Table2"
                  index={0}
                  title={["Tube No.", "Loc A", "Loc B", "Loc C", "Loc D"]}
                  numberofrowsdisabled={0}
                  status={[
                    error.WPQ_MEX_Tube_No.status,
                    error.WPQ_MEX_LocA.status,
                    error.WPQ_MEX_LocB.status,
                    error.WPQ_MEX_LocC.status,
                    error.WPQ_MEX_LocD.status,
                  ]}
                  message={[
                    error.WPQ_MEX_Tube_No.message,
                    error.WPQ_MEX_LocA.message,
                    error.WPQ_MEX_LocB.message,
                    error.WPQ_MEX_LocC.message,
                    error.WPQ_MEX_LocD.message,
                  ]}
                  handleChangetestarray={handleChangeMacro_Examinationarray}
                />
              </Col>
              {/* ////////////////////////3nd table ////////////////////////////////////////////*/}
            </Row>
          </Row>
          <Row style={{ padding: "20px 60px" }}>
            <Col md={6} style={{ height: "215px" }}>
              <PQRPage3TableColumnNindex
                columns={2}
                array={Macro_Examination5}
                setheaderObj={setheaderObj}
                setError={setError}
                name={["WPQ_MEX_Magnification", "WPQ_MEX_Acceptance_Criteria"]}
                title={["Magnification", "Acceptance Criteria"]}
                table="Table5"
                status={[
                  error.WPQ_MEX_Magnification.status,
                  error.WPQ_MEX_Acceptance_Criteria.status,
                ]}
                message={[
                  error.WPQ_MEX_Magnification.message,
                  error.WPQ_MEX_Acceptance_Criteria.message,
                ]}
                width={[10, 10]}
                handleChangetestarray={handleChangeMacro_Examinationarray5}
                maxLength={[16, 11]}
              />
            </Col>
            <Col md={6} style={{ height: "215px" }}>
              <WPQPage3Table3observation
                setheaderObj={setheaderObj}
                setError={setError}
                name3="WPQ_MEX_Observation"
                table="Table5"
                value3={detailObj?.WPQ_MEX_Observation}
                maxLength3={180}
                status2={error.WPQ_MEX_Observation.status}
                message2={error.WPQ_MEX_Observation.message}
                handleChangetestarray={handleChangeNotes}
                valueNotes={valueNotes}
              />
            </Col>
          </Row>
          <Row
            style={{
              padding: "0px 60px",
              position: "relative",
              bottom: "20px",
            }}
          >
            <span
              className="WPS-blue-text"
              style={{ position: "relative", right: "11px", top: "10px" }}
            >
              Result
            </span>
            <Row className="mb-1">
              <Col md={12}>
                <div className="T-input w-100">
                  <input
                    type="text"
                    id="WPQ_MEX_Result"
                    name="WPQ_MEX_Result"
                    maxLength={60}
                    placeholder=" "
                    value={detailObj?.WPQ_MEX_Result}
                    onChange={handleChangedetail}
                    onInput={(e) => {
                      let error = isAlphanumericWithPlusAmpersandEqualsPercentMinus(
                        e.target.value
                      );
                      setError((prevState) => ({
                        ...prevState,
                        WPQ_MEX_Result: error,
                      }));
                    }}
                  />
                  <Form.Label htmlFor="WPQ_MEX_Result">Result</Form.Label>
                </div>
                {error.WPQ_MEX_Result.status && (
                  <Form.Text className="text-danger">
                    {error.WPQ_MEX_Result.message}
                  </Form.Text>
                )}
              </Col>
            </Row>
          </Row>
        </Row>
      </fieldset>
    );
  }
);

export default WPQ_Tubesheet_Page3;
